var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('FullScreen'),_c('Video'),_c('Description'),_c('Levels'),_c('Artisans'),_c('ProjectTeam'),_c('Nature'),_c('NearbyPoints'),_c('Form'),_c('Footer'),_c('Modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }